import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import pages from './modules/page'
import applet from './modules/applet'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    pages,
    applet
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js